module.exports = __webpack_public_path__ + "static/jj_climbing-3aad76eb351b84b415878f4b783dc3e8.jpg";